import React, { useEffect, Suspense, lazy, createElement } from 'react';
import { UrgencyBar } from './components/UrgencyBar';
import { HeroSection } from './components/HeroSection';
import { TransformationSection } from './components/TransformationSection';
import { RealResultsSection } from './components/RealResultsSection';
import { FloatingOffer } from './components/FloatingOffer';
const SolutionSection = lazy(() => import('./components/SolutionSection').then(m => ({
  default: m.SolutionSection
})));
const IncludesSection = lazy(() => import('./components/IncludesSection').then(m => ({
  default: m.IncludesSection
})));
const BonusesSection = lazy(() => import('./components/BonusesSection').then(m => ({
  default: m.BonusesSection
})));
const UrgencyOfferSection = lazy(() => import('./components/UrgencyOfferSection').then(m => ({
  default: m.UrgencyOfferSection
})));
const PricingSection = lazy(() => import('./components/PricingSection').then(m => ({
  default: m.PricingSection
})));
const TestimonialsSection = lazy(() => import('./components/TestimonialsSection').then(m => ({
  default: m.TestimonialsSection
})));
const FAQSection = lazy(() => import('./components/FAQSection').then(m => ({
  default: m.FAQSection
})));
const FooterSection = lazy(() => import('./components/FooterSection').then(m => ({
  default: m.FooterSection
})));
const SocialProofPopup = lazy(() => import('./components/SocialProofPopup').then(m => ({
  default: m.SocialProofPopup
})));
export function App() {
  useEffect(() => {
    const meta = document.createElement('meta');
    meta.name = 'facebook-domain-verification';
    meta.content = 'ukxbt6i9cor3c23xr4j0lek38bvd3m';
    document.head.appendChild(meta);
    const preconnects = ['https://fonts.googleapis.com', 'https://fonts.gstatic.com', 'https://cdn.magicpatterns.com'];
    const links: HTMLLinkElement[] = [];
    preconnects.forEach(href => {
      const link = document.createElement('link');
      link.rel = 'preconnect';
      link.href = href;
      link.crossOrigin = 'anonymous';
      document.head.appendChild(link);
      links.push(link);
    });
    return () => {
      document.head.removeChild(meta);
      links.forEach(link => document.head.removeChild(link));
    };
  }, []);
  return <div className="w-full min-h-screen bg-white" data-id="element-0" data-mp="86cld4uwd7jn">
      <UrgencyBar data-id="element-1" data-mp="3gkuxpirvf992" />
      <HeroSection data-id="element-2" data-mp="3gm64lrgm4x4e" />
      <TransformationSection data-id="element-3" data-mp="3glo067jsrcle" />
      <RealResultsSection data-id="element-4" data-mp="3bmbf9schkflg" />

      <Suspense fallback={<div className="min-h-[200px]" data-id="element-6" data-mp="3bnmfji6q357t" />} data-id="element-5" data-mp="3bn2zk70muqwf">
        <SolutionSection data-id="element-7" data-mp="3bkguce17snhd" />
        <IncludesSection data-id="element-8" data-mp="3qbpql5zmh73h" />
        <TestimonialsSection data-id="element-9" data-mp="3qbze8mx73260" />
        <BonusesSection data-id="element-10" data-mp="3qdajysa7ajzr" />
        <UrgencyOfferSection data-id="element-11" data-mp="3lkr6dvbijouy" />
        <PricingSection data-id="element-12" data-mp="3ljg1fs6c0b29" />
        <FAQSection data-id="element-13" data-mp="3lj6aa19jvxuz" />
        <FooterSection data-id="element-14" data-mp="3limq0dwfgxds" />
        <SocialProofPopup data-id="element-15" data-mp="2xudatutpz7vm" />
      </Suspense>
      <FloatingOffer data-id="element-16" data-mp="2xtc05rgm8nef" />
    </div>;
}